<section class="relative overflow-hidden  lg:py-32" aria-labelledby="hero-heading">
  <!-- Background gradient effect -->
  <div class="absolute inset-0 bg-dark-blue">
    <div class="absolute w-full h-full opacity-20">
      <div class="absolute top-20 -left-24 w-72 h-72 bg-electric-blue rounded-full filter blur-[80px]"></div>
      <div class="absolute bottom-10 right-20 w-72 h-72 bg-magenta rounded-full filter blur-[80px]"></div>
    </div>
  </div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="relative">
      <!-- Hero visual - full width -->
      <div class="w-full" data-aos="fade-up">
        <div
            class="relative z-10 rounded-xl overflow-hidden shadow-glow border border-white/10 h-auto min-h-[80vh] md:h-[600px] lg:h-[650px]">
          <!-- Replace with a clean image without text -->
          <div
              class="w-full h-full bg-gradient-to-br from-dark-blue via-background-charcoal to-background-gray relative overflow-hidden">
            <!-- More subtle visual elements in the background -->
            <div
                class="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-electric-blue rounded-full filter blur-[120px] opacity-10 animate-pulse-slow"></div>
            <div
                class="absolute bottom-1/3 right-1/3 w-[400px] h-[400px] bg-magenta rounded-full filter blur-[120px] opacity-10 animate-pulse-slow"
                style="animation-delay: 2s;"></div>
            <div
                class="absolute top-1/2 left-2/3 w-[300px] h-[300px] bg-teal-400 rounded-full filter blur-[100px] opacity-8 animate-pulse-slow"
                style="animation-delay: 4s;"></div>
          </div>

          <!-- Semi-transparent overlay for better text readability -->
          <div class="absolute inset-0 bg-gradient-to-b from-dark-blue/80 via-transparent to-dark-blue/80 z-10"></div>
        </div>

        <!-- Visual decorative elements -->
        <div
            class="absolute -top-4 -right-4 w-20 h-20 rounded-full bg-gradient-to-r from-electric-blue to-magenta opacity-50 blur-lg"></div>
        <div
            class="absolute -bottom-4 -left-4 w-16 h-16 rounded-full bg-gradient-to-r from-magenta to-electric-blue opacity-50 blur-lg"></div>
      </div>

      <!-- Hero text content - positioned on top of the image -->
      <div
          class="absolute inset-0 z-20 flex flex-col justify-start md:justify-center items-center text-center px-4 md:px-12 lg:px-20 pt-12 md:pt-0"
          data-aos="fade-in" data-aos-delay="200">
        <div class="flex items-center justify-center mb-4 sm:mb-6 md:mb-8">
          <img alt="" class="h-12 sm:h-16 md:h-20 lg:h-24 w-auto drop-shadow-lg" src="logo.webp">
          <!-- Animated AI Music Icon -->
          <div class="ml-3 md:ml-4 flex items-center">
            <svg class="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-16 lg:h-16" fill="none" viewBox="0 0 48 48"
                 xmlns="http://www.w3.org/2000/svg">
              <!-- AI Brain outline -->
              <path class="ai-brain"
                    d="M24 8c-6.627 0-12 5.373-12 12 0 1.5.3 3 .8 4.3L8 28c-1.1 0-2 .9-2 2s.9 2 2 2h4.8c1.5 2.5 4.1 4.3 7.2 4.8V40c0 1.1.9 2 2 2s2-.9 2-2v-3.2c3.1-.5 5.7-2.3 7.2-4.8H36c1.1 0 2-.9 2-2s-.9-2-2-2l-4.8-3.7c.5-1.3.8-2.8.8-4.3 0-6.627-5.373-12-12-12z"
                    fill="none" opacity="0.7" stroke="url(#gradient1)" stroke-width="2"/>

              <!-- Animated sound waves -->
              <g class="sound-waves">
                <path class="wave wave-1" d="M24 2c2-2 2-4 0-6" fill="none" stroke="url(#gradient2)"
                      stroke-linecap="round" stroke-width="2"/>
                <path class="wave wave-2" d="M46 24c2-2 4-2 6 0" fill="none" stroke="url(#gradient2)"
                      stroke-linecap="round" stroke-width="2"/>
                <path class="wave wave-3" d="M24 46c-2 2-2 4 0 6" fill="none" stroke="url(#gradient2)"
                      stroke-linecap="round" stroke-width="2"/>
                <path class="wave wave-4" d="M2 24c-2 2-4 2-6 0" fill="none" stroke="url(#gradient2)"
                      stroke-linecap="round" stroke-width="2"/>
              </g>

              <!-- Musical notes -->
              <g class="musical-notes">
                <circle class="note note-1" cx="39" cy="9" fill="url(#gradient3)" r="1.5"/>
                <circle class="note note-2" cx="39" cy="39" fill="url(#gradient3)" r="1.5"/>
                <circle class="note note-3" cx="9" cy="39" fill="url(#gradient3)" r="1.5"/>
                <circle class="note note-4" cx="9" cy="9" fill="url(#gradient3)" r="1.5"/>
              </g>

              <!-- Gradient definitions -->
              <defs>
                <linearGradient id="gradient1" x1="0%" x2="100%" y1="0%" y2="100%">
                  <stop class="[stop-color:theme(colors.electric-blue)]" offset="0%"/>
                  <stop class="[stop-color:theme(colors.magenta)]" offset="100%"/>
                </linearGradient>
                <linearGradient id="gradient2" x1="0%" x2="100%" y1="0%" y2="0%">
                  <stop class="[stop-color:theme(colors.electric-blue)]" offset="0%"/>
                  <stop class="[stop-color:theme(colors.magenta)]" offset="100%"/>
                </linearGradient>
                <linearGradient id="gradient3" x1="0%" x2="100%" y1="0%" y2="100%">
                  <stop class="[stop-color:theme(colors.magenta)]" offset="0%"/>
                  <stop offset="100%" style="stop-color:#00a2ff"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>

        <h1 id="hero-heading" class="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold pb-2 mb-4 sm:mb-6 md:mb-8 bg-gradient-to-r from-electric-blue to-magenta bg-clip-text text-transparent drop-shadow-lg">
          Visual to Soundtrack Matching
        </h1>

        <p class="text-base sm:text-lg md:text-xl text-white mb-4 sm:mb-6 md:mb-8 max-w-2xl drop-shadow-md">
          AI that analyzes images and video to instantly deliver emotionally aligned music.
        </p>

        <div class="flex flex-wrap gap-3 sm:gap-4 mb-6 sm:mb-8 md:mb-10 justify-center">
          <a class="btn btn-primary" href="#demo">
            Try Demo
          </a>
          <a class="btn btn-secondary" href="#how-it-works">
            How It Works
          </a>
        </div>

        <!-- Key stats with visual effects instead of counting -->
        <div
            class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 lg:gap-16 w-full px-4 md:px-0 sm:max-w-4xl mt-4 md:mt-8 pb-4 md:pb-0">
          <div
              class="stat-card backdrop-blur-md bg-dark-blue/40 transform hover:scale-105 transition-transform border-l-4 border-electric-blue">
            <div class="relative overflow-hidden">
              <div class="text-xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-electric-blue to-magenta bg-clip-text text-transparent relative z-10">
                X10</div>
            </div>
            <p class="text-sm md:text-base lg:text-lg text-white mt-1 md:mt-2">Faster Song Selection</p>
          </div>

          <div
              class="stat-card backdrop-blur-md bg-dark-blue/40 transform hover:scale-105 transition-transform border-l-4 border-electric-blue">
            <div class="relative overflow-hidden">
              <div class="text-xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-electric-blue to-magenta bg-clip-text text-transparent relative z-10">
                X3</div>
            </div>
            <p class="text-sm md:text-base lg:text-lg text-white mt-1 md:mt-2">More Engagements</p>
          </div>

          <div
              class="stat-card backdrop-blur-md bg-dark-blue/40 transform hover:scale-105 transition-transform border-l-4 border-electric-blue">
            <div class="relative overflow-hidden">
              <div class="text-xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-electric-blue to-magenta bg-clip-text text-transparent relative z-10">
                100%</div>
            </div>
            <p class="text-sm md:text-base lg:text-lg text-white mt-1 md:mt-2">Contextual Precision</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
